module.exports = __webpack_public_path__ + "img/news-draw.96532d92.png";